const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the pie chart component
 * @argument {Application} Application the service defined to manage Application specific tools and functions
 */


app.directive('pieChart', [function () {
  return {
    restrict: 'EA',
    replace: true,
    scope: {
      data: '=',
      colors: '=?',
      customlabels: '=?',
      hidepercent: '=?'
    },
    template: require('../../templates/directives/pie-chart.html'),
    link: function (scope, element, attrs) {
      var self = this;
      var pieCanvas = document.getElementById("pie-canvas");
      var legendElem = document.getElementById("pie-legend");

      self.isEmoji = function(str){
        var res = str.match(/^\&\#/);
        if (res){
          return true;
        } else {
          return false;
        }
      };

      self.shouldHidePercent = function(){
        if(scope.hidepercent && scope.hidepercent === true) {
          return false;
        } else {
          return true;
        }
      };

      scope.colors = scope.colors || ['#36c26e','#21bef1', '#e86257', '#fd8126', '#c9cacb'];

      pieCanvas.width = 600;
      pieCanvas.height = 600;
      pieCanvas.style.width = '300px';
      pieCanvas.style.height = '300px';

      var ctx = pieCanvas.getContext("2d");

      function drawPieSlice(ctx,centerX, centerY, radius, startAngle, endAngle, color ){
        ctx.fillStyle = color;
        ctx.strokeStyle="#F7F7F7";
        ctx.lineWidth=4;
        ctx.beginPath();
        ctx.moveTo(centerX,centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fill();
        ctx.stroke();
      };

      var Piechart = function(options){
        this.options = options;
        this.canvas = options.canvas;
        this.ctx = this.canvas.getContext("2d");
        this.colors = options.colors;

        this.draw = function(){
          var total_value = 0;
          var color_index = 0;
          var legendHTML = "";

          for (var categ in this.options.data){
            var val = this.options.data[categ];
            total_value += val;
          }

          var start_angle = 0;
          for (categ in this.options.data) {
            val = this.options.data[categ];
            var slice_angle = 2 * Math.PI * val / total_value;

            drawPieSlice(
              this.ctx,
              this.canvas.width/2,
              this.canvas.height/2,
              Math.min(this.canvas.width/2,this.canvas.height/2),
              start_angle,
              start_angle+slice_angle,
              this.colors[color_index]
            );

            var pieRadius = Math.min(this.canvas.width/2,this.canvas.height/2);
            var labelX = this.canvas.width/2 + (pieRadius / 2) * Math.cos(start_angle + slice_angle/2);
            var labelY = this.canvas.height/2 + (pieRadius / 2) * Math.sin(start_angle + slice_angle/2);

            var labelText = Math.round(100 * val / total_value);
            this.ctx.fillStyle = "white";
            this.ctx.textAlign="center";
            this.ctx.textBaseline="middle";
            this.ctx.font = "45px 'Gotham Rounded SSm A','Gotham Rounded SSm B',Helvetica,Arial,sans-serif";
            if (labelText > 0 && self.shouldHidePercent()){
              this.ctx.fillText(labelText+"%", labelX ,labelY);
            }
            var percent = total_value === 0 ? 0 : Math.round(100 * val / total_value);
            legendHTML += "<div class='" + (self.isEmoji(categ) ? 'emoji' : '') + "'><span style='display:inline-block;width:20px;background-color:" + this.colors[color_index] + ";'>&nbsp;</span> " + ( scope.customlabels ? scope.customlabels[color_index] : categ) + " <b>(" + percent + "&#37;)</b></div>";

            start_angle += slice_angle;
            color_index++;
          }

          this.options.legend.innerHTML = legendHTML;
        };

      };

      self.init = function init () {
        self.pieChart = new Piechart({
          canvas: pieCanvas,
          data: scope.data,
          colors: scope.colors,
          legend: legendElem
        });
        self.pieChart.draw();
      };

      scope.$watch('data', function(newVal, oldVal) {
        if (newVal) {
          self.init();
        }
      }, true);

      if (scope.data) {
        self.init();
      }

    }
  };
}]);
